import * as React from 'react';
import {ProductsPriceFilterViewBaseProps} from '../model';
import {useIsDesktop} from '../../../../shared/hooks/useIsDesktop';
import {ProductsPriceFilterDesktop} from './views/desktop';
import {ProductsPriceFilterMobile} from './views/mobile';
import {ProductsPriceFilterVisuallyImpaired} from './views/visuallyImpaired';

interface Props extends ProductsPriceFilterViewBaseProps {
  visuallyImpaired?: boolean;
}

export default ({visuallyImpaired, ...props}: Props) => {
  const isDesktop = useIsDesktop();

  if (visuallyImpaired) {
    return <ProductsPriceFilterVisuallyImpaired {...props} />;
  } else {
    return isDesktop ? <ProductsPriceFilterDesktop {...props} /> : <ProductsPriceFilterMobile {...props} />;
  }
};
